[
  {
    "id": "MET-E7-L205-001",
    "module": "Metriek",
    "difficulty": 205,
    "question": "Je fietst 18 km/u. Hoe ver kom je in 20 minuten?",
    "options": [
      "6 km",
      "9 km",
      "3 km",
      "4,5 km"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "snelheid_tijd",
    "subSkill": "snelheid",
    "familyId": "MET-SNELHEID-20MIN",
    "explanation": "20 minuten is $\\frac{1}{3}$ uur. $\\frac{1}{3}$ van 18 km is 6 km.",
    "distractorExplanations": {
      "1": "Dat is in 30 minuten (de helft).",
      "2": "Dat is in 10 minuten.",
      "3": "Dat is in 15 minuten (een kwart)."
    }
  },
  {
    "id": "MET-E7-L205-002",
    "module": "Metriek",
    "difficulty": 205,
    "question": "Reken om: 0,003 km³ = ... m³",
    "options": [
      "3.000.000 m³",
      "3.000 m³",
      "300 m³",
      "30.000 m³"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-KM3-M3",
    "explanation": "Van km³ naar m³ is ×1.000.000.000 (3 stappen van ×1.000). 0,003 × 1.000.000.000 = 3.000.000 m³.",
    "distractorExplanations": {
      "1": "Je hebt met 1.000.000 gerekend.",
      "2": "Je hebt met 100.000 gerekend.",
      "3": "Je hebt met 10.000.000 gerekend."
    }
  },
  {
    "id": "MET-E7-L205-003",
    "module": "Metriek",
    "difficulty": 205,
    "question": "Een wiel heeft een omtrek van 2 meter. Hoe vaak draait het rond over 1 km?",
    "options": [
      "500 keer",
      "200 keer",
      "1.000 keer",
      "2.000 keer"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "omtrek",
    "subSkill": "omtrek",
    "familyId": "MET-WIEL-KM",
    "explanation": "1 km = 1.000 meter. 1.000 : 2 = 500 keer.",
    "distractorExplanations": {
      "1": "Rekenfout.",
      "2": "Je hebt 1.000 × 2 gedaan.",
      "3": "Je hebt de meters niet omgerekend."
    }
  },
  {
    "id": "MET-E7-L205-004",
    "module": "Metriek",
    "difficulty": 205,
    "question": "Reken om: 750 cc = ... liter",
    "options": [
      "0,75 liter",
      "7,5 liter",
      "75 liter",
      "0,075 liter"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-CC-L",
    "explanation": "cc betekent cm³ = ml. 750 ml = 0,75 liter.",
    "distractorExplanations": {
      "1": "Dat is 750 cl.",
      "2": "Dat is 750 dl.",
      "3": "Dat is 75 ml."
    }
  },
  {
    "id": "MET-E7-L205-005",
    "module": "Metriek",
    "difficulty": 205,
    "question": "Hoeveel m² is 3,5 are?",
    "options": [
      "350 m²",
      "35 m²",
      "3.500 m²",
      "35.000 m²"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "oppervlakte",
    "subSkill": "oppervlakte_omrekenen",
    "familyId": "MET-ARE-M2",
    "explanation": "1 are = 100 m². 3,5 are = 350 m².",
    "distractorExplanations": {
      "1": "Je hebt met 10 vermenigvuldigd.",
      "2": "Je hebt met 1.000 vermenigvuldigd.",
      "3": "Je hebt met 10.000 vermenigvuldigd."
    }
  },
  {
    "id": "MET-E7-L205-006",
    "module": "Metriek",
    "difficulty": 205,
    "question": "Een veld is 2,5 hectare. Hoeveel vierkante meter is dat?",
    "options": [
      "25.000 m²",
      "2.500 m²",
      "250.000 m²",
      "250 m²"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "oppervlakte",
    "subSkill": "oppervlakte_omrekenen",
    "familyId": "MET-HA-M2-E7",
    "explanation": "1 ha = 10.000 m². 2,5 × 10.000 = 25.000 m².",
    "distractorExplanations": {
      "1": "Je deed ×1.000. Maar 1 ha = 10.000 m².",
      "2": "Je deed ×100.000.",
      "3": "Je deed ×100."
    }
  },
  {
    "id": "MET-E7-L205-007",
    "module": "Metriek",
    "difficulty": 205,
    "question": "Een container is 6 m lang, 2,5 m breed en 2,5 m hoog. Hoeveel kubieke meter is de inhoud?",
    "options": [
      "37,5 m³",
      "15 m³",
      "75 m³",
      "11 m³"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-INH-CONTAINER",
    "explanation": "Inhoud = 6 × 2,5 × 2,5 = 37,5 m³.",
    "distractorExplanations": {
      "1": "Je deed 6 × 2,5. Maar je moet ook × de hoogte.",
      "2": "Je deed 37,5 × 2. Dat is te veel.",
      "3": "Je telde de maten op."
    }
  },
  {
    "id": "MET-E7-L205-008",
    "module": "Metriek",
    "difficulty": 205,
    "question": "Reken om: 4.500 dm² = ... m²",
    "options": [
      "45 m²",
      "4,5 m²",
      "450 m²",
      "0,45 m²"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "oppervlakte",
    "subSkill": "oppervlakte_omrekenen",
    "familyId": "MET-DM2-M2-E7",
    "explanation": "1 m² = 100 dm². Dus 4.500 : 100 = 45 m².",
    "distractorExplanations": {
      "1": "Je deelde door 1.000.",
      "2": "Je deelde door 10.",
      "3": "Je deelde door 10.000."
    }
  },
  {
    "id": "MET-E7-L205-009",
    "module": "Metriek",
    "difficulty": 205,
    "question": "Een driehoek heeft een basis van 18 cm en een hoogte van 12 cm. Wat is de oppervlakte?",
    "options": [
      "108 cm²",
      "216 cm²",
      "30 cm²",
      "54 cm²"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "oppervlakte",
    "subSkill": "oppervlakte_driehoek",
    "familyId": "MET-OPP-DRIEHOEK-E7",
    "explanation": "Oppervlakte driehoek = (basis × hoogte) : 2 = (18 × 12) : 2 = 216 : 2 = 108 cm².",
    "distractorExplanations": {
      "1": "Je bent vergeten te delen door 2.",
      "2": "Je hebt 18 + 12 gedaan.",
      "3": "Je deed (18 × 6) : 2. De hoogte is 12, niet 6."
    }
  },
  {
    "id": "MET-E7-L205-010",
    "module": "Metriek",
    "difficulty": 205,
    "question": "Een auto rijdt 90 km/u. Hoeveel meter legt hij af in 1 seconde?",
    "options": [
      "25 m",
      "90 m",
      "15 m",
      "9 m"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "snelheid_tijd",
    "subSkill": "snelheid",
    "familyId": "MET-KMU-MS-E7",
    "explanation": "90 km/u = 90.000 m per 3.600 seconden. 90.000 : 3.600 = 25 m/s.",
    "distractorExplanations": {
      "1": "Dat is de snelheid in km/u, niet in m/s.",
      "2": "Je deelde door 6.000 in plaats van 3.600.",
      "3": "Je deelde door 10.000."
    }
  },
  {
    "id": "MET-E7-L205-011",
    "module": "Metriek",
    "difficulty": 205,
    "question": "Een bak is 1,2 m lang, 0,5 m breed en 0,4 m hoog. Hoeveel liter past erin?",
    "options": [
      "240 liter",
      "24 liter",
      "2.400 liter",
      "2,1 liter"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-INH-BAK-E7",
    "explanation": "Zet om naar dm: 12 × 5 × 4 = 240 dm³ = 240 liter.",
    "distractorExplanations": {
      "1": "Je vergat een factor 10 bij het omrekenen.",
      "2": "Je rekende met cm zonder om te rekenen.",
      "3": "Je telde de maten op."
    }
  },
  {
    "id": "MET-E7-L205-012",
    "module": "Metriek",
    "difficulty": 205,
    "question": "Hoeveel are is 0,75 hectare?",
    "options": [
      "75 are",
      "7,5 are",
      "750 are",
      "0,75 are"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "oppervlakte",
    "subSkill": "oppervlakte_omrekenen",
    "familyId": "MET-HA-ARE",
    "explanation": "1 ha = 100 are. 0,75 × 100 = 75 are.",
    "distractorExplanations": {
      "1": "Je deed ×10.",
      "2": "Je deed ×1.000.",
      "3": "Je zette niets om."
    }
  },
  {
    "id": "MET-E7-L205-013",
    "module": "Metriek",
    "difficulty": 205,
    "question": "Een rechthoekig stuk grond is 120 m lang en 80 m breed. Hoeveel hectare is dat?",
    "options": [
      "0,96 ha",
      "9,6 ha",
      "96 ha",
      "0,096 ha"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "oppervlakte",
    "subSkill": "oppervlakte_omrekenen",
    "familyId": "MET-OPP-HA-E7",
    "explanation": "Oppervlakte = 120 × 80 = 9.600 m². 1 ha = 10.000 m². 9.600 : 10.000 = 0,96 ha.",
    "distractorExplanations": {
      "1": "Je deelde door 1.000 in plaats van 10.000.",
      "2": "Je deelde door 100.",
      "3": "Je deelde door 100.000."
    }
  },
  {
    "id": "MET-E7-L205-014",
    "module": "Metriek",
    "difficulty": 205,
    "question": "Reken om: 2,4 dm³ = ... ml",
    "options": [
      "2.400 ml",
      "240 ml",
      "24 ml",
      "24.000 ml"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-DM3-ML-E7",
    "explanation": "1 dm³ = 1 liter = 1.000 ml. 2,4 × 1.000 = 2.400 ml.",
    "distractorExplanations": {
      "1": "Je deed ×100.",
      "2": "Je deed ×10.",
      "3": "Je deed ×10.000."
    }
  },
  {
    "id": "MET-E7-L205-015",
    "module": "Metriek",
    "difficulty": 205,
    "question": "Een schilderij is 60 cm breed en 80 cm hoog. Wat is de oppervlakte in dm²?",
    "options": [
      "48 dm²",
      "4,8 dm²",
      "480 dm²",
      "28 dm²"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "oppervlakte",
    "subSkill": "oppervlakte",
    "familyId": "MET-OPP-SCHILDERIJ-E7",
    "explanation": "Zet om naar dm: 6 dm × 8 dm = 48 dm². Of: 60 × 80 = 4.800 cm². 4.800 : 100 = 48 dm².",
    "distractorExplanations": {
      "1": "Je deelde door 1.000 in plaats van 100.",
      "2": "Je vergat om te rekenen van cm² naar dm².",
      "3": "Je berekende de omtrek in plaats van de oppervlakte."
    }
  }
]